import { selfAxios } from "@oppein/op-utils";
/**
 * 删除取号标签
 */
export async function deleteByIdValidateOrgPermissions(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerMainContactLabel/deleteByIdValidateOrgPermissions",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/customerMainContactLabel/deleteByIdValidateOrgPermissions/post.js